import { SignatureDisclaimerType } from 'src/api';

export const disclaimerTypeEnumToString = (signatureType: number): string => {
    switch (signatureType) {
        case SignatureDisclaimerType.NUMBER_1:
            return 'California Contractor State License Board';
        default:
            return '';
    }
};
